import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import __ from '../utils/translator';
import { NavLink, Link, withRouter } from 'react-router-dom';
import ThronModal from "./ThronModal";
import buttonMutedStyle from '../utils/buttonMutedStyle';
import ConfidentialIcon from './ConfidentialIcon';
import Color from 'color';
import JwtStore from "../flux/JwtStore";
import OutletOnlyLabel from "./OutletOnlyLabel";
import OutletOnlyIcon from "./OutletOnlyIcon";

const SUB_MENU_ITEM_SEASONAL = 'SEASONAL';
const SUB_MENU_ITEM_MANUALS = 'MANUALS';
const SUB_MENU_ITEM_TIMELESS = 'TIMELESS';
const SUB_MENU_ITEM_GLOSSARY = 'GLOSSARY';
const SUB_MENU_ITEM_PRODUCT_FOCUS = 'PRODUCT FOCUS';


function getActiveSubMenuItem(pathname) {
  switch (true) {
    default:
    case pathname.startsWith('/seasonal'):
      return SUB_MENU_ITEM_SEASONAL;

    case pathname.startsWith('/manuals'):
      return SUB_MENU_ITEM_MANUALS;

    case pathname.startsWith('/timeless'):
      return SUB_MENU_ITEM_TIMELESS;

    case pathname.startsWith('/glossary'):
      return SUB_MENU_ITEM_GLOSSARY;

    case pathname.startsWith('/product-focuses'):
      return SUB_MENU_ITEM_PRODUCT_FOCUS;
  }
}

class HeaderSubMenu extends Component {
  static defaultProps = {
    collections: [],
    categories: [],
    onCloseSubMenuClick: null,
    shouldShowArchiveLink: false,
  };

  state = {
    active: getActiveSubMenuItem(this.props.location.pathname),
    collections: this.props.collections,
    categories: this.props.categories
  };

  onMediaClick = manual => {
    this.setState({
      thronModalOpened: true,
      manualAssetClicked: manual,
    });
  };

  onThronModalCloseButtonClick = () => {
    this.setState({ thronModalOpened: false, manualAssetClicked: null});
  };

  // @todo 2018-06-01 Use Context to get the collections.
  // @todo 2018-06-01 Have a root context for the list of collections maybes? Mh.
  // @todo 2018-06-01 Maybe wrap with an HOC like withCollections(...)? mh.

  static getDerivedStateFromProps(nextProps, state) {
    const nextState = {};

    if (nextProps.collections !== state.collections) {
      nextState.collections = nextProps.collections;
    }

    if (nextProps.categories !== state.categories) {
      nextState.categories = nextProps.categories;
    }

    return Object.keys(nextState).length > 0
      ? nextState
      : null
  }

  onSeasonalClick = () => {
    this.setActive(SUB_MENU_ITEM_SEASONAL);
  };

  onManualsClick = () => {
    this.setActive(SUB_MENU_ITEM_MANUALS);
  };

  onTimelessClick = () => {
    this.setActive(SUB_MENU_ITEM_TIMELESS);
  };

  setActive = active => {
    this.setState({ active });
  };

  render() {
    return (
      <SubMenu>
        <SubMenuHead>
          <SubMenuHeadInner>
            <SubMenuLinkContainer onClick={this.onSeasonalClick}>
              <SubMenuLink name={SUB_MENU_ITEM_SEASONAL} current={this.state.active}>
                {__('Seasonal')}
              </SubMenuLink>
            </SubMenuLinkContainer>

            <SubMenuLinkContainer onClick={this.onManualsClick}>
              <SubMenuLink name={SUB_MENU_ITEM_MANUALS} current={this.state.active}>
                {__('Manuals')}
              </SubMenuLink>
            </SubMenuLinkContainer>

            <SubMenuLinkContainer onClick={this.onTimelessClick}>
              <SubMenuLink name={SUB_MENU_ITEM_TIMELESS} current={this.state.active}>
                {__('Timeless')}
              </SubMenuLink>
            </SubMenuLinkContainer>

            <SubMenuLinkContainer>
              <Link to={`/glossary`}>
                <SubMenuLinkContainer>
                  <SubMenuLink name={SUB_MENU_ITEM_GLOSSARY} current={this.state.active}>{__('Glossary')}</SubMenuLink>
                </SubMenuLinkContainer>
              </Link>
            </SubMenuLinkContainer>

            {JwtStore.isAvailableFeature('product-focus') && (
              <SubMenuLinkContainer>
                <Link to={`/product-focuses`}>
                  <SubMenuLinkContainer>
                    <SubMenuLink name={SUB_MENU_ITEM_PRODUCT_FOCUS} current={this.state.active}>
                      {__('Product Focus')}
                    </SubMenuLink>
                  </SubMenuLinkContainer>
                </Link>
              </SubMenuLinkContainer>
            )}
          </SubMenuHeadInner>
        </SubMenuHead>

        {this.state.active === SUB_MENU_ITEM_SEASONAL && (
          <React.Fragment>
            <SubMenuBody>
              {this.state.collections.slice(0, 4).map(collection => (
                <ul key={collection.id}>
                  <li>
                    {collection.confidential && (
                      <ConfidentialIcon style={{ marginRight: '.5rem' }}/>
                    )}
                    <strong><Link to={`/seasonal/${collection.id}`}>{collection.name}</Link></strong>
                  </li>

                  {collection.themes.map(theme => (
                    <li key={theme.id}>
                      {theme.confidential && (
                        <ConfidentialIcon style={{ marginRight: '.5rem' }}/>
                      )}
                      {theme.visibleOnlyForOutlets && (
                        <OutletOnlyIcon small />
                      )}
                      <NavLink activeStyle={{ fontWeight: 'bolder', }}  to={`/seasonal/${collection.id}/themes/${theme.id}`}>
                        {theme.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              ))}
            </SubMenuBody>

            {this.props.shouldShowArchiveLink && (
              <SubMenuBodyBottomLink to={`/archive`} style={{ color: 'rgb(28,28,28)', fontWeight: 'bold' }}>
                + {JwtStore.isOnlyOutletEmployee() ? __('View all') : __('Go to archive')}
              </SubMenuBodyBottomLink>
            )}
          </React.Fragment>
        )}

        {this.state.active === SUB_MENU_ITEM_MANUALS && (
          <React.Fragment>
            <SubMenuBody>
              {this.state.collections.slice(0, 4).map(collection => (
                <ul key={collection.id}>
                  <li>
                    {collection.confidential && (
                      <ConfidentialIcon style={{ marginRight: '.5rem' }} />
                    )}
                    {collection.manuals.length > 0 ? (
                      <strong><Link to={`/seasonal/${collection.id}/manuals`}>{collection.name}</Link></strong>
                    ) : (
                      <strong style={{ color: '#aaa' }}>{collection.name}</strong>
                    )}
                  </li>

                  {collection.manuals.map(manual => (
                    <li key={manual.id}>
                      <button style={{ ...buttonMutedStyle, cursor: 'pointer', textAlign: 'left', }} onClick={() => this.onMediaClick(manual)}>
                        {manual.name}
                      </button>
                    </li>
                  ))}
                </ul>
              ))}
            </SubMenuBody>

            {this.state.collections.reduce((manuals, c) => manuals.concat(c.manuals), []).length > 0 && (
              <SubMenuBodyBottomLink to={`/manuals`} style={{ color: 'rgb(28,28,28)', fontWeight: 'bold' }}>
                + {__('View all')}
              </SubMenuBodyBottomLink>
            )}
          </React.Fragment>
        )}

        {this.state.active === SUB_MENU_ITEM_TIMELESS && (
          <React.Fragment>
            <SubMenuBody>
              {this.state.categories.slice(0, 4).map(category => (
                <ul key={category.id}>
                  <li>
                    {category.confidential && (
                      <ConfidentialIcon style={{ marginRight: '.5rem' }}/>
                    )}
                    <strong><Link to={`/timeless/${category.id}`}>{category.name}</Link></strong>
                  </li>

                  {category.themes.slice(0, 13).map(theme => (
                    <li key={theme.id}>
                      {theme.confidential && (
                        <ConfidentialIcon style={{ marginRight: '.5rem' }}/>
                      )}
                      {theme.visibleOnlyForOutlets && (
                        <OutletOnlyIcon small />
                      )}
                      <NavLink activeStyle={{ fontWeight: 'bolder', }} to={`/timeless/${category.id}/themes/${theme.id}`}>
                        {theme.name}
                      </NavLink>
                    </li>
                  ))}

                  {category.themes.length > 13 && (
                    <NavLink to={`/timeless/${category.id}`}>
                      + {__('View all')}
                    </NavLink>
                  )}
                </ul>
              ))}
            </SubMenuBody>

            {this.state.categories.length > 0 && (
              <SubMenuBodyBottomLink to={`/timeless`} style={{ color: 'rgb(28,28,28)', fontWeight: 'bold' }}>
                + {__('View all')}
              </SubMenuBodyBottomLink>
            )}
          </React.Fragment>
        )}

        <SubMenuCloseButton onClick={this.props.onCloseSubMenuClick} style={{ ...buttonMutedStyle, padding: '.75rem 1rem', color: '#1c1c1c', }}>
          {__('Close')}
        </SubMenuCloseButton>

        {this.state.thronModalOpened && (
          createPortal(
            <ThronModal asset={this.state.manualAssetClicked} onCloseButtonClick={this.onThronModalCloseButtonClick}/>,
            window.document.body
          )
        )}
      </SubMenu>
    );
  }
}

export default withRouter(HeaderSubMenu);

const SubMenu = styled.div`
  z-index: 99;
  position: absolute;
  top: 3.25rem;
  right: 0;
  left: 0;
  background-color: ${props => Color(props.theme.secondaryBackgroundColorNegative).alpha(.97).toString()};
  border-bottom: 2px solid rgba(0,0,0,0.1);
`;

const SubMenuHead = styled.div`
  border-top: 2px solid rgba(0,0,0,.1);
  border-bottom: 1px solid rgba(0,0,0,.1);
`;

const SubMenuHeadInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 1rem;
  max-width: 64rem;
  margin-right: auto;
  margin-left: auto;
  padding: 0.75rem 1rem;
`;

const SubMenuLinkContainer = styled.div`
  text-transform: uppercase;
	display: inline;
	// Remove tap highlight
	// @todo 2018-05-11 Extract appearance for link as button
	-webkit-tap-highlight-color: rgba(0,0,0,0);
  flex-basis: 25%;
  padding: .5rem 0;
  background-color: transparent;
	border: none;
	text-align: left;
	cursor: pointer;
	outline: none;
`;

const SubMenuLink = styled.span`
  color: rgba(28,28,28,.5);
  padding-bottom: 0.25rem;

  ${props => props.name === props.current && css`
    font-weight: bold;
    color: #1c1c1c;
    border-bottom: 0.125rem solid rgba(51,51,51,0.5);
  `};
`;

const SubMenuBody = styled.div`
  display: flex;
  gap: 1rem;
  max-width: 64rem;
  margin: 0 auto;
  padding-right: 1rem;
  padding-left: 1rem;

  > ul {
    flex-basis: 25%;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0.5rem 0;
    list-style: none;
    line-height: 2.5;
  }

  > ul > li {
    display: flex;
    align-items: center;
    line-height: 1.5rem;
    margin: .5rem 0;
    padding-right: .25rem;
    padding-left: .25rem;
    color: rgba(28,28,28);
  }

  > ul > li a,
  > ul > li span  {
    color: rgb(28,28,28);
  }
`;

const SubMenuBodyBottomLinkContainer = styled.div`
  max-width: 64rem;
  margin-right: auto;
  margin-left: auto;
  padding: 1rem;
  text-align: right;
  text-transform: uppercase;
`;

const SubMenuBodyBottomLink = props => {
  return (
    <SubMenuBodyBottomLinkContainer>
      <Link {...props} />
    </SubMenuBodyBottomLinkContainer>
  )
};

const SubMenuCloseButton = styled.button`
  width: 100%;
`;
